<template>
  <CContainer>
    <h3>Ejecucion Presupuestos de Ventas por Categorias</h3>
    <CCard class="mt-4">
      <CCardBody>
        <CRow class="mt-2">
          <CCol sm="3">
            <div class="form-group" role="group">
              <label class="text-muted font-weight-bold col-sm-12" for="">Periodo Inicial:</label>
              <DatePicker 
                type="month" 
                class="col-sm-12" 
                v-model="initialPeriod"
                value-type="YYYYMM"
                format="MM/YYYY"
                placeholder="mm/aaaa" />
              {{ initialPeriod }}
            </div>
          </CCol>
          <CCol sm="3">
            <div class="form-group" role="group">
              <label class="text-muted font-weight-bold col-sm-12" for="">Periodo Final:</label>
              <DatePicker 
                type="month" 
                v-model="finalPeriod"
                value-type="YYYYMM"
                format="YYYY/MM"
                placeholder="aaaa/mm" />
              {{ finalPeriod }}
            </div>
          </CCol>
          <CCol sm="6">
            <CSelect 
              class="col-sm-12"
              addLabelClasses="text-muted font-weight-bold" 
              label="Empleado:" 
              invalidFeedback="El Empleado no ha sido asignado."
              :options="employees.map(item => { return { value: item.id_Personal, label: item.nombre_Empleado }})"
              :value.sync="selectedEmployee"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="3">
            <CSelect
              class="col-sm-12"
              addLabelClasses="text-muted front-weight-bold"
              label="Moneda:" 
              disabled
              :options="typesMoney"
              :value.sync="selectedTypeMoney"
            />
          </CCol>
          <CCol sm="2" class="d-flex align-items-end">
            <CButton color="dark" class="mb-3" variant="outline" @click="updateChart()">
              <CIcon name="cil-search"/>
              <span class="ml-2 align-middle">Consultar</span>
            </CButton>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <CCard class="mt-4">
      <CCardBody class="p-5">
        <sales-budget-execution-chart v-if="updateComponent > 0"
          :showTitle="false"
          :initialPeriod="initialPeriod"
          :finalPeriod="finalPeriod"
          :idEmployee="idEmployee"
          :key="updateComponent" >
        </sales-budget-execution-chart>
      </CCardBody>
    </CCard>
</CContainer>
</template>
<script>
  import moment from "moment"
  import DatePicker from "vue2-datepicker"
  import SalesBudgetExecutionChart from '../charts/SalesBudgetExecutionChart.vue'
  import {
    dataListPersonal
  } from '../../api.js'

  export default {
    name: 'SalesBudgetExecution',
    data() {
      return {
        loading: false,
        updateComponent: 0,
        initialPeriod: '',
        finalPeriod: '',
        employees: [],
        selectedEmployee: '',
        idEmployee: '',
        typesMoney: [
          {
            label: 'Pesos',
            value: 'COP'
          },
          {
            label: 'Dolares',
            value: 'USD'
          }
        ],
        selectedTypeMoney: ''
      }
    },
    components: {
      DatePicker,
      SalesBudgetExecutionChart
    },
    methods: {
      async getEmployees(){
        try {
          const data = await dataListPersonal(this)
          this.employees = [{ id_Personal: '', nombre_Empleado: "Seleccionar" }, ...data]
        } catch {
          console.log()
        }
      },
      updateChart() {
        if (this.initialPeriod && this.finalPeriod) {

          this.idEmployee = this.selectedEmployee.length ? this.selectedEmployee : null
          this.updateComponent += 1
        }
      },
    },
    async mounted() {
      // await this.$store.dispatch('statusLogin', this.$router)

      this.initialPeriod = moment().startOf('year').format("YYYYMM")
      this.finalPeriod = moment().format("YYYYMM")

      this.updateComponent = 1

      await this.getEmployees()
    },
  }
</script>